import Vue from 'vue'

const components = {

  // Tiles
  'ticker-tile': () => import('@/components/ChartsTiles/TickerTile.vue'),
  'note-tile': () => import('@/components/ChartsTiles/NoteTile.vue'),
  'donut-tile': () => import('@/components/ChartsTiles/DonutTile.vue'),
  'wallet-tile': () => import('@/components/ChartsTiles/WalletTile.vue'),

  // Charts
  'line-chart': () => import('@/components/Сharts/LineChart.vue'),
  'donut-chart': () => import('@/components/Сharts/DonutChart.vue'),


  
}

Object.entries(components).forEach(([name, component]) => Vue.component(name, component))